import {PgTerminationRequest} from '../../models/policy.model';
import {ValidationError} from '../../models/validation-error.model';

export namespace PolicyPgActions {
    export class FetchById {
        static readonly type = 'PolicyPgActions.FetchById';

        constructor(public id: number) {
        }
    }

    export class Clear {
        static readonly type = 'PolicyPgActions.Clear';
    }

    export class PaymentConfirmation {
        static readonly type = 'PolicyPgActions.ConfirmPayment';

        constructor(public id: number) {
        }
    }

    export class CancelPolicy {
        static readonly type = 'PolicyPgActions.CancelPolicy';

        constructor(public id: number) {
        }
    }

    export class TerminatePolicy {
        static readonly type = 'PolicyPgActions.TerminatePolicy';

        constructor(public policyId: number, public payload: PgTerminationRequest) {
        }
    }

    export class TerminatePolicyAside {
        static readonly type = 'PolicyPgActions.TerminatePolicyAside';

        constructor(public policyId: number) {
        }
    }

    export class OpenDownloadPolicyModal {
        static readonly type = 'PolicyPgActions.OpenDownloadPolicyModal';
    }

    export class DownloadPolicyPrintout {
        static readonly type = 'PolicyPgActions.DownloadPolicyPrintout';

        constructor(public policyId: string, public addKidOwu?: boolean) {
        }
    }

    export class GetInstallmentsAndClaims {
        static readonly type = 'PolicyPgActions.GetInstallmentsAndClaims';
    }

    export class FormFailure {
        static readonly type = '[PolicyPg] FormFailure';

        constructor(public readonly validationErrors: ValidationError[]) {}
    }
}
